module.exports = __webpack_public_path__ + "static/media/cao-hac-sam-6.3e80f74d.jpg";